import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CompareContext = createContext();
const KEY = "ztm_compare";
const MAX = 4;

export const CompareProvider = ({ children }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) setItems(JSON.parse(raw));
    } catch (e) {}
  }, []);

  const persist = (next) => {
    setItems(next);
    localStorage.setItem(KEY, JSON.stringify(next));
  };

  const inCompare = (id) => items.some((i) => i.id === id);

  const snapshot = (p) => ({
    id: p.id, name: p.name, brand: p.brand, image: p.image, category: p.category,
    slug: p.slug, price: p.price, currency: p.currency, tags: p.tags, purity_score: p.purity_score,
  });

  const toggleCompare = (product) => {
    if (inCompare(product.id)) {
      persist(items.filter((i) => i.id !== product.id));
      return false;
    }
    if (items.length >= MAX) {
      toast.error(`Puedes comparar hasta ${MAX} productos.`);
      return false;
    }
    persist([...items, snapshot(product)]);
    return true;
  };

  const addMany = (products) => {
    const next = [...items];
    for (const p of products) {
      if (next.length >= MAX) break;
      if (!next.some((i) => i.id === p.id)) next.push(snapshot(p));
    }
    persist(next);
  };

  const removeCompare = (id) => persist(items.filter((i) => i.id !== id));
  const clearCompare = () => persist([]);

  return (
    <CompareContext.Provider value={{ items, inCompare, toggleCompare, addMany, removeCompare, clearCompare, count: items.length, MAX }}>
      {children}
    </CompareContext.Provider>
  );
};

export const useCompare = () => useContext(CompareContext);
